import Layout from "./Layout/Layout";
import {Route, Switch, Redirect} from "react-router";
import Home from "./Container/Home/Home";
import Crew from "./Container/Crew/Crew";
import Destination from "./Container/Destination/Destination";
import Technology from "./Container/Technology/Technology";

function App() {

  const route = (
  <Switch>
    <Route path="/home" exact component={ Home }/>
    <Route path="/destination" component={ Destination }/>
    <Route path="/crew" component={ Crew }/>
    <Route path="/technology" component={ Technology }/>
    <Redirect to="/home" />
  </Switch>)


  return (
    <div className=" h-full">
    <Layout>
      {route}
    </Layout>
    </div>
  );
}

export default App;
